import { render } from "./RoundTabsTeacher.vue?vue&type=template&id=eba82f10&scoped=true"
import script from "./RoundTabsTeacher.vue?vue&type=script&lang=js"
export * from "./RoundTabsTeacher.vue?vue&type=script&lang=js"

import "./RoundTabsTeacher.vue?vue&type=style&index=0&id=eba82f10&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eba82f10"]])

export default __exports__